
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25 .49A24.51 24.51 0 1049.51 25 24.53 24.53 0 0025 .49zm11.31 27.29a2.76 2.76 0 01-2.61-1.84h-4a5 5 0 01-.7 1.7l2.84 2.84A2.77 2.77 0 1131 35a2.78 2.78 0 01-.56-3.13L27.64 29a4.47 4.47 0 01-1.7.7v4a2.78 2.78 0 11-1.88 0v-4a5 5 0 01-1.7-.7l-2.84 2.8A2.77 2.77 0 1115 31a2.78 2.78 0 013.13-.56L21 27.61a4.34 4.34 0 01-.71-1.7h-4a2.77 2.77 0 110-1.85h4a5 5 0 01.7-1.7l-2.79-2.84A2.77 2.77 0 1119 15a2.78 2.78 0 01.56 3.13L22.39 21a4.34 4.34 0 011.7-.71v-4a2.78 2.78 0 111.88 0v4a5 5 0 011.7.7l2.84-2.84a2.73 2.73 0 01.55-3.13 2.78 2.78 0 11.8 4.48L29 22.36a4.47 4.47 0 01.7 1.7h4a2.78 2.78 0 112.61 3.72z","fill":"var(--primary-highlight)"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/tools_svgs/aiFill.svg